import { API_ROOT as API_BASE } from './environment'
export default {
  LOGIN: API_BASE + '/app/login',
  CONFIGURATION: API_BASE + '/app/configuration',
  SERVICE_CONFIGURATION: API_BASE + '/app/services/{serviceId}/configuration',
  ME_BOOKINGS: API_BASE + '/app/me/bookings',
  ME_SETTINGS: API_BASE + '/app/me/settings',
  ME_REGISTRATION_CARDS: API_BASE + '/app/me/registration-cards',
  ME_PASSWORD: API_BASE + '/app/me/credentials/password',
  ACCOUNTS: API_BASE + '/app/accounts/',
  REGISTRATION_CARDS: API_BASE + '/app/guests/{guestId}/registration-cards',
  REGISTRATION_CARDS_DOCUMENT_SCAN: API_BASE + '/app/guests/{guestId}/registration-cards/document/scan',
  REGISTRATION_CARDS_DOCUMENT: API_BASE + '/app/guests/{guestId}/registration-cards/document/verify',
  REGISTRATION_CARDS_CONTACT: API_BASE + '/app/guests/{guestId}/registration-cards/contact',
  REGISTRATION_CARDS_SIGNATURE: API_BASE + '/app/guests/{guestId}/registration-cards/signature',
  REGISTRATION_CARDS_FILE: API_BASE + '/app/guests/{guestId}/registration-cards/files/{fileId}',
  PUBLIC_FILES: API_BASE + '/app/public/files/{fileId}',
  DOCUMENT_SIGNED_FILE: API_BASE + '/app/guests/{guestId}/registration-cards/files/{fileId}',
  ME_FACILITIES: API_BASE + '/app/me/facilities',
  CREDENTIALS_SEND: API_BASE + '/app/credentials/send',
  TRANSACTIONS: API_BASE + '/app/transactions',
  ACTIVITY_CATEGORIES: API_BASE + '/app/activity-categories',
  ACTIVITIES: API_BASE + '/app/activities',
  ACTIVITY_ID_WORKING_HOURS: API_BASE + '/app/activities/{activityId}/working-hours',
  ACTIVITIES_ID: API_BASE + '/app/activities/{activityId}',
  ACTIVITY_ID_SLOTS: API_BASE + '/app/activities/{activityId}/slots',
  ACTIVITY_ID_SLOTS_CAPACITY: API_BASE + '/app/activities/{activityId}/slots/capacity',
  ACTIVITY_ID_RESERVATIONS: API_BASE + '/app/activities/{activityId}/reservations',
  ACTIVITY_RESERVATIONS: API_BASE + '/app/activity-reservations',
  ACTIVITY_RESERVATIONS_ID: API_BASE + '/app/activity-reservations/{activityReservationId}',
  ACTIVITY_ID_CATALOG: API_BASE + '/app/activities/{activityId}/catalogs',
  ACTIVITY_RESERVATIONS_ID_TICKET: API_BASE + '/app/activity-reservations/{activityReservationId}/ticket/{ticketId}',
  ACTIVITY_RESERVATIONS_ID_MODIFY: API_BASE + '/app/activity-reservations/{id}/modify',
  ACTIVITY_RESERVATIONS_ID_CANCEL: API_BASE + '/app/activity-reservations/{id}/cancel',
  ACTIVITY_RESERVATIONS_HISTORY: API_BASE + '/app/activity-reservations/{id}/history',
  CURRENCIES: API_BASE + '/app/currencies',
}
